import React from "react";

import "./CmsEntry.css";


//============================================================
//
// Eva Entry Card
//
//============================================================

export default function CmsEntryCard(
    {
        title,
        description,
        image,
        siteType,
        selected = false,
        isAddNew = false,
        onClick
    }
)
{

    //--------------------------------------------------------
    // Add New
    //--------------------------------------------------------

	if (isAddNew)
	{
	    return (

	        <button
	            type="button"
	            className="cms-entry-card cms-entry-card-add"
	            onClick={onClick}
	        >

	            <div className="cms-entry-card-image cms-entry-add-image">

	                <div className="cms-entry-add-symbol">
	                    +
	                </div>

	            </div>

	            <div className="cms-entry-card-body cms-entry-add-body">

	                <div className="cms-entry-card-title">
	                    {title}
	                </div>

	                <div className="cms-entry-card-description">
	                    {description}
	                </div>

	            </div>

	        </button>

	    );
	}


    //========================================================
    // Standard Card
    //========================================================

    return (

		<button
		    type="button"
		    className={
		        "cms-entry-card"
		        +
		        (
		            siteType === "EVA"
		                ? " cms-entry-card-eva"
		                : ""
		        )
		        +
		        (
		            selected
		                ? " cms-entry-card-selected"
		                : ""
		        )
		    }
		    onClick={onClick}
		>

            <div className="cms-entry-card-image">

                {
                    image
                    ?
                    <img
                        src={image}
                        alt={title}
                    />
                    :
                    <div className="cms-entry-card-placeholder">

                        <span className="cms-entry-placeholder-symbol">
                            {siteType === "EVA" ? "E" : "W"}
                        </span>

                    </div>
                }

                <div className="cms-entry-card-image-shade" />

                <span className="cms-entry-card-type">
                    {siteType === "EVA" ? "EVA" : "WEBSITE"}
                </span>

            </div>


            <div className="cms-entry-card-body">

                <div className="cms-entry-card-title">
                    {title}
                </div>

                <div className="cms-entry-card-description">
                    {description}
                </div>

            </div>

        </button>

    );

}